<div class="content-bar">
  <div class="displayFlex">
    <div class="displayFlex contentTitle">
      <p class="textAlert bold">Alertas asignadas</p>
      <p class="textAlert">VS</p>
      <p class="textAlert bold">Alertas solucionadas</p>
    </div>
    <button
      (click)="selected = 'Diario'; getWeek()"
      [ngClass]="{ selectedClass: selected == 'Diario' }"
      mat-stroked-button
      #buttonDiario
    >
      Semana
    </button>
    <button
      (click)="selected = 'Semanal'; getMonth()"
      [ngClass]="{ selectedClass: selected == 'Semanal' }"
      mat-stroked-button
      class="margin-side"
    >
      Mes
    </button>
    <button
      (click)="selected = 'Mensual'; getYear()"
      [ngClass]="{ selectedClass: selected == 'Mensual' }"
      mat-stroked-button
    >
      Año
    </button>
  </div>

  <div>
    <div
      class="divChart"
      #assignedVsSolvedContentLine
      id="assignedVsSolvedContentLine"
    >
      <canvas
        #assignedVsSolvedContent
        id="assignedVsSolvedContent"
        height="300"
        style="height: 300px"
      ></canvas>
    </div>
  </div>
</div>
